import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _obj, _init;
import Controller, { inject as controller } from "@ember/controller";
import { action } from "@ember/object";
import { gt, or } from "@ember/object/computed";
import { service } from "@ember/service";
import { isEmpty } from "@ember/utils";
import { Promise } from "rsvp";
import TopicBulkActions from "discourse/components/modal/topic-bulk-actions";
import { ajax } from "discourse/lib/ajax";
import { search as searchCategoryTag } from "discourse/lib/category-tag-search";
import { setTransient } from "discourse/lib/page-tracker";
import { getSearchKey, isValidSearchTerm, logSearchLinkClick, reciprocallyRankedList, searchContextDescription, translateResults, updateRecentSearches } from "discourse/lib/search";
import userSearch from "discourse/lib/user-search";
import { escapeExpression } from "discourse/lib/utilities";
import { scrollTop } from "discourse/mixins/scroll-top";
import Category from "discourse/models/category";
import Composer from "discourse/models/composer";
import discourseComputed, { bind, observes } from "discourse-common/utils/decorators";
import I18n from "discourse-i18n";
const SortOrders = [{
  name: I18n.t("search.relevance"),
  id: 0
}, {
  name: I18n.t("search.latest_post"),
  id: 1,
  term: "order:latest"
}, {
  name: I18n.t("search.most_liked"),
  id: 2,
  term: "order:likes"
}, {
  name: I18n.t("search.most_viewed"),
  id: 3,
  term: "order:views"
}, {
  name: I18n.t("search.latest_topic"),
  id: 4,
  term: "order:latest_topic"
}];
export const SEARCH_TYPE_DEFAULT = "topics_posts";
export const SEARCH_TYPE_CATS_TAGS = "categories_tags";
export const SEARCH_TYPE_USERS = "users";
const PAGE_LIMIT = 10;
const customSearchTypes = [];
export function registerFullPageSearchType(translationKey, searchTypeId, searchFunc) {
  customSearchTypes.push({
    translationKey,
    searchTypeId,
    searchFunc
  });
}
export default Controller.extend((_dec = discourseComputed("resultCount"), _dec2 = discourseComputed("expanded"), _dec3 = discourseComputed("q"), _dec4 = discourseComputed("q"), _dec5 = discourseComputed("skip_context", "context"), _dec6 = discourseComputed("context", "context_id"), _dec7 = discourseComputed("q"), _dec8 = discourseComputed("q"), _dec9 = discourseComputed("canCreateTopic", "siteSettings.login_required"), _dec10 = observes("sortOrder"), _dec11 = observes("search_type"), _dec12 = observes("model"), _dec13 = discourseComputed("q"), _dec14 = observes("q"), _dec15 = discourseComputed("q"), _dec16 = discourseComputed("resultCount", "noSortQ"), _dec17 = observes("model.{posts,categories,tags,users}.length", "searchResultPosts"), _dec18 = discourseComputed("hasResults"), _dec19 = discourseComputed("selected.length", "searchResultPosts.length"), _dec20 = discourseComputed("model.grouped_search_result.can_create_topic"), _dec21 = discourseComputed("page"), _dec22 = discourseComputed("search_type"), _dec23 = discourseComputed("search_type"), _dec24 = discourseComputed("bulkSelectEnabled"), _dec25 = discourseComputed("model.posts", "additionalSearchResults"), (_obj = {
  application: controller(),
  composer: service(),
  modal: service(),
  appEvents: service(),
  siteSettings: service(),
  searchPreferencesManager: service(),
  bulkSelectEnabled: null,
  loading: false,
  queryParams: ["q", "expanded", "context_id", "context", "skip_context", "search_type"],
  q: undefined,
  context_id: null,
  search_type: SEARCH_TYPE_DEFAULT,
  context: null,
  searching: false,
  sortOrder: 0,
  sortOrders: SortOrders,
  invalidSearch: false,
  page: 1,
  resultCount: null,
  searchTypes: null,
  additionalSearchResults: [],
  selected: [],
  error: null,
  init() {
    this._super(...arguments);
    this.set("sortOrder", this.searchPreferencesManager.sortOrder || this.siteSettings.search_default_sort_order);
    const searchTypes = [{
      name: I18n.t("search.type.default"),
      id: SEARCH_TYPE_DEFAULT
    }, {
      name: this.siteSettings.tagging_enabled ? I18n.t("search.type.categories_and_tags") : I18n.t("search.type.categories"),
      id: SEARCH_TYPE_CATS_TAGS
    }, {
      name: I18n.t("search.type.users"),
      id: SEARCH_TYPE_USERS
    }];
    customSearchTypes.forEach(type => {
      searchTypes.push({
        name: I18n.t(type.translationKey),
        id: type.searchTypeId
      });
    });
    this.set("searchTypes", searchTypes);
  },
  hasResults(resultCount) {
    return (resultCount || 0) > 0;
  },
  expandFilters(expanded) {
    return expanded === "true";
  },
  hasAutofocus(q) {
    return isEmpty(q);
  },
  highlightQuery(q) {
    if (!q) {
      return;
    }
    return q.split(/\s+/).filter(t => t !== "l").join(" ");
  },
  searchContextEnabled: {
    get(skip, context) {
      return !skip && context || skip === "false";
    },
    set(val) {
      this.set("skip_context", !val);
    }
  },
  searchContextDescription(context, id) {
    let name = id;
    if (context === "category") {
      let category = Category.findById(id);
      if (!category) {
        return;
      }
      name = category.get("name");
    }
    return searchContextDescription(context, name);
  },
  searchActive(q) {
    return isValidSearchTerm(q, this.siteSettings);
  },
  noSortQ(q) {
    q = this.cleanTerm(q);
    return escapeExpression(q);
  },
  showSuggestion(canCreateTopic, loginRequired) {
    return canCreateTopic || !loginRequired;
  },
  _searchOnSortChange: true,
  setSearchTerm(term) {
    this._searchOnSortChange = false;
    term = this.cleanTerm(term);
    this._searchOnSortChange = true;
    this.set("searchTerm", term);
  },
  cleanTerm(term) {
    if (term) {
      SortOrders.forEach(order => {
        if (order.term) {
          let matches = term.match(new RegExp(`${order.term}\\b`));
          if (matches) {
            this.set("sortOrder", order.id);
            term = term.replace(new RegExp(`${order.term}\\b`, "g"), "");
            term = term.trim();
          }
        }
      });
    }
    return term;
  },
  triggerSearch() {
    if (this._searchOnSortChange) {
      this.set("page", 1);
      this._search();
    }
  },
  triggerSearchOnTypeChange() {
    if (this.searchActive) {
      this.set("page", 1);
      this._search();
    }
  },
  modelChanged() {
    if (this.searchTerm !== this.q) {
      this.setSearchTerm(this.q);
    }
  },
  showLikeCount(q) {
    return q?.includes("order:likes");
  },
  qChanged() {
    const model = this.model;
    if (model && this.get("model.q") !== this.q) {
      this.setSearchTerm(this.q);
      this.send("search");
    }
  },
  isPrivateMessage(q) {
    return q && this.currentUser && (q.includes("in:messages") || q.includes("in:personal") || q.includes(`personal_messages:${this.currentUser.get("username_lower")}`));
  },
  resultCountLabel(count, term) {
    const plus = count % 50 === 0 ? "+" : "";
    return I18n.t("search.result_count", {
      count,
      plus,
      term
    });
  },
  resultCountChanged() {
    if (!this.model.posts) {
      return 0;
    }
    this.set("resultCount", this.searchResultPosts.length + this.model.categories.length + this.model.tags.length + this.model.users.length);
  },
  canBulkSelect(hasResults) {
    return this.currentUser && this.currentUser.staff && hasResults;
  },
  hasSelection: gt("selected.length", 0),
  hasUnselectedResults(selectionCount, postsCount) {
    return selectionCount < postsCount;
  },
  canCreateTopic(userCanCreateTopic) {
    return this.currentUser && userCanCreateTopic;
  },
  isLastPage(page) {
    return page === PAGE_LIMIT;
  },
  usingDefaultSearchType(searchType) {
    return searchType === SEARCH_TYPE_DEFAULT;
  },
  customSearchType(searchType) {
    return customSearchTypes.find(type => searchType === type["searchTypeId"]);
  },
  searchInfoClassNames(bulkSelectEnabled) {
    return bulkSelectEnabled ? "search-info bulk-select-visible" : "search-info";
  },
  searchResultPosts(posts, additionalSearchResults) {
    if (additionalSearchResults?.list?.length > 0) {
      return reciprocallyRankedList([posts, additionalSearchResults.list], ["topic_id", additionalSearchResults.identifier]);
    } else {
      return posts;
    }
  },
  searchButtonDisabled: or("searching", "loading"),
  _search() {
    if (this.searching) {
      return;
    }
    this.set("invalidSearch", false);
    const searchTerm = this.searchTerm;
    if (!isValidSearchTerm(searchTerm, this.siteSettings)) {
      this.set("invalidSearch", true);
      return;
    }
    let args = {
      q: searchTerm,
      page: this.page
    };
    if (args.page === 1) {
      this.set("bulkSelectEnabled", false);
      this.selected.clear();
      this.set("searching", true);
      scrollTop();
    } else {
      this.set("loading", true);
    }
    const sortOrder = this.sortOrder;
    if (sortOrder && SortOrders[sortOrder].term) {
      args.q += " " + SortOrders[sortOrder].term;
    }
    this.set("q", args.q);
    const skip = this.skip_context;
    if (!skip && this.context || skip === "false") {
      args.search_context = {
        type: this.context,
        id: this.context_id
      };
    }
    const searchKey = getSearchKey(args);
    if (this.customSearchType) {
      const customSearch = this.customSearchType["searchFunc"];
      customSearch(this, args, searchKey);
      return;
    }
    switch (this.search_type) {
      case SEARCH_TYPE_CATS_TAGS:
        const categoryTagSearch = searchCategoryTag(searchTerm, this.siteSettings);
        Promise.resolve(categoryTagSearch).then(async results => {
          const categories = results.filter(c => Boolean(c.model));
          const tags = results.filter(c => !c.model);
          const model = (await translateResults({
            categories,
            tags
          })) || {};
          this.set("model", model);
        }).finally(() => {
          this.setProperties({
            searching: false,
            loading: false
          });
        });
        break;
      case SEARCH_TYPE_USERS:
        userSearch({
          term: searchTerm,
          limit: 20
        }).then(async results => {
          const model = (await translateResults({
            users: results
          })) || {};
          this.set("model", model);
        }).finally(() => {
          this.setProperties({
            searching: false,
            loading: false
          });
        });
        break;
      default:
        if (this.currentUser) {
          updateRecentSearches(this.currentUser, searchTerm);
        }
        ajax("/search", {
          data: args
        }).then(async results => {
          const model = (await translateResults(results)) || {};
          if (results.grouped_search_result) {
            this.set("q", results.grouped_search_result.term);
          }
          if (args.page > 1) {
            if (model) {
              this.model.posts.pushObjects(model.posts);
              this.model.topics.pushObjects(model.topics);
              this.model.set("grouped_search_result", results.grouped_search_result);
            }
          } else {
            setTransient("lastSearch", {
              searchKey,
              model
            }, 5);
            model.grouped_search_result = results.grouped_search_result;
            this.set("model", model);
          }
          this.set("error", null);
        }).catch(e => {
          this.set("error", e.jqXHR.responseJSON?.message);
        }).finally(() => {
          this.setProperties({
            searching: false,
            loading: false
          });
        });
        break;
    }
  },
  _afterTransition() {
    if (Object.keys(this.model).length === 0) {
      this.reset();
    }
  },
  reset() {
    this.setProperties({
      searching: false,
      page: 1,
      resultCount: null,
      selected: []
    });
  },
  createTopic(searchTerm, event) {
    event?.preventDefault();
    let topicCategory;
    if (searchTerm.includes("category:")) {
      const match = searchTerm.match(/category:(\S*)/);
      if (match && match[1]) {
        topicCategory = match[1];
      }
    }
    this.composer.open({
      action: Composer.CREATE_TOPIC,
      draftKey: Composer.NEW_TOPIC_KEY,
      topicCategory
    });
  },
  addSearchResults(list, identifier) {
    this.set("additionalSearchResults", {
      list,
      identifier
    });
  },
  setSortOrder(value) {
    this.set("sortOrder", value);
    this.searchPreferencesManager.sortOrder = value;
  },
  actions: {
    selectAll() {
      this.selected.addObjects(this.get("searchResultPosts").mapBy("topic"));

      // Doing this the proper way is a HUGE pain,
      // we can hack this to work by observing each on the array
      // in the component, however, when we select ANYTHING, we would force
      // 50 traversals of the list
      // This hack is cheap and easy
      document.querySelectorAll(".fps-result input[type=checkbox]").forEach(checkbox => {
        checkbox.checked = true;
      });
    },
    clearAll() {
      this.selected.clear();
      document.querySelectorAll(".fps-result input[type=checkbox]").forEach(checkbox => {
        checkbox.checked = false;
      });
    },
    toggleBulkSelect() {
      this.toggleProperty("bulkSelectEnabled");
      this.selected.clear();
    },
    showBulkActions() {
      this.modal.show(TopicBulkActions, {
        model: {
          topics: this.selected,
          refreshClosure: this._search
        }
      });
    },
    search() {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (this.searching) {
        return;
      }
      if (options.collapseFilters) {
        document.querySelector("details.advanced-filters")?.removeAttribute("open");
      }
      this.set("page", 1);
      this.appEvents.trigger("full-page-search:trigger-search");
      this._search();
    },
    loadMore() {
      let page = this.page;
      if (this.get("model.grouped_search_result.more_full_page_results") && !this.loading && page < PAGE_LIMIT) {
        this.incrementProperty("page");
        this._search();
      }
    },
    logClick(topicId) {
      if (this.get("model.grouped_search_result.search_log_id") && topicId) {
        logSearchLinkClick({
          searchLogId: this.get("model.grouped_search_result.search_log_id"),
          searchResultId: topicId,
          searchResultType: "topic"
        });
      }
    }
  }
}, (_applyDecoratedDescriptor(_obj, "hasResults", [_dec], Object.getOwnPropertyDescriptor(_obj, "hasResults"), _obj), _applyDecoratedDescriptor(_obj, "expandFilters", [_dec2], Object.getOwnPropertyDescriptor(_obj, "expandFilters"), _obj), _applyDecoratedDescriptor(_obj, "hasAutofocus", [_dec3], Object.getOwnPropertyDescriptor(_obj, "hasAutofocus"), _obj), _applyDecoratedDescriptor(_obj, "highlightQuery", [_dec4], Object.getOwnPropertyDescriptor(_obj, "highlightQuery"), _obj), _applyDecoratedDescriptor(_obj, "searchContextEnabled", [_dec5], (_init = Object.getOwnPropertyDescriptor(_obj, "searchContextEnabled"), _init = _init ? _init.value : undefined, {
  enumerable: true,
  configurable: true,
  writable: true,
  initializer: function () {
    return _init;
  }
}), _obj), _applyDecoratedDescriptor(_obj, "searchContextDescription", [_dec6], Object.getOwnPropertyDescriptor(_obj, "searchContextDescription"), _obj), _applyDecoratedDescriptor(_obj, "searchActive", [_dec7], Object.getOwnPropertyDescriptor(_obj, "searchActive"), _obj), _applyDecoratedDescriptor(_obj, "noSortQ", [_dec8], Object.getOwnPropertyDescriptor(_obj, "noSortQ"), _obj), _applyDecoratedDescriptor(_obj, "showSuggestion", [_dec9], Object.getOwnPropertyDescriptor(_obj, "showSuggestion"), _obj), _applyDecoratedDescriptor(_obj, "triggerSearch", [_dec10], Object.getOwnPropertyDescriptor(_obj, "triggerSearch"), _obj), _applyDecoratedDescriptor(_obj, "triggerSearchOnTypeChange", [_dec11], Object.getOwnPropertyDescriptor(_obj, "triggerSearchOnTypeChange"), _obj), _applyDecoratedDescriptor(_obj, "modelChanged", [_dec12], Object.getOwnPropertyDescriptor(_obj, "modelChanged"), _obj), _applyDecoratedDescriptor(_obj, "showLikeCount", [_dec13], Object.getOwnPropertyDescriptor(_obj, "showLikeCount"), _obj), _applyDecoratedDescriptor(_obj, "qChanged", [_dec14], Object.getOwnPropertyDescriptor(_obj, "qChanged"), _obj), _applyDecoratedDescriptor(_obj, "isPrivateMessage", [_dec15], Object.getOwnPropertyDescriptor(_obj, "isPrivateMessage"), _obj), _applyDecoratedDescriptor(_obj, "resultCountLabel", [_dec16], Object.getOwnPropertyDescriptor(_obj, "resultCountLabel"), _obj), _applyDecoratedDescriptor(_obj, "resultCountChanged", [_dec17], Object.getOwnPropertyDescriptor(_obj, "resultCountChanged"), _obj), _applyDecoratedDescriptor(_obj, "canBulkSelect", [_dec18], Object.getOwnPropertyDescriptor(_obj, "canBulkSelect"), _obj), _applyDecoratedDescriptor(_obj, "hasUnselectedResults", [_dec19], Object.getOwnPropertyDescriptor(_obj, "hasUnselectedResults"), _obj), _applyDecoratedDescriptor(_obj, "canCreateTopic", [_dec20], Object.getOwnPropertyDescriptor(_obj, "canCreateTopic"), _obj), _applyDecoratedDescriptor(_obj, "isLastPage", [_dec21], Object.getOwnPropertyDescriptor(_obj, "isLastPage"), _obj), _applyDecoratedDescriptor(_obj, "usingDefaultSearchType", [_dec22], Object.getOwnPropertyDescriptor(_obj, "usingDefaultSearchType"), _obj), _applyDecoratedDescriptor(_obj, "customSearchType", [_dec23], Object.getOwnPropertyDescriptor(_obj, "customSearchType"), _obj), _applyDecoratedDescriptor(_obj, "searchInfoClassNames", [_dec24], Object.getOwnPropertyDescriptor(_obj, "searchInfoClassNames"), _obj), _applyDecoratedDescriptor(_obj, "searchResultPosts", [_dec25], Object.getOwnPropertyDescriptor(_obj, "searchResultPosts"), _obj), _applyDecoratedDescriptor(_obj, "_search", [bind], Object.getOwnPropertyDescriptor(_obj, "_search"), _obj), _applyDecoratedDescriptor(_obj, "createTopic", [action], Object.getOwnPropertyDescriptor(_obj, "createTopic"), _obj), _applyDecoratedDescriptor(_obj, "addSearchResults", [action], Object.getOwnPropertyDescriptor(_obj, "addSearchResults"), _obj), _applyDecoratedDescriptor(_obj, "setSortOrder", [action], Object.getOwnPropertyDescriptor(_obj, "setSortOrder"), _obj)), _obj)));